import * as React from "react"

import { isNumber } from "../../../../../../util/Strings"

import CreateWorkspace from "./CreateWorkspace"
import UnavailableLink from "../UnavailableLink"
import Workspace from "./Workspace"
import WorkspaceCover from "./WorkspaceCover"
import WorkspaceTutorial from "./WorkspaceTutorial"

interface Props {
    attributes: Record<string, string>
    customLabel: string
    label: string
    linkParameters: string[]
}

export const WorkspaceInternalLink = ({
    attributes,
    customLabel,
    label,
    linkParameters,
}: Props): JSX.Element => {
    if (linkParameters.length === 2) {
        if (isNumber(linkParameters[1])) {
            // WORKSPACE.[WORKSPACEID] => OPENS THE GIVEN WORKSPACE
            return (
                <Workspace
                    attributes={attributes}
                    customLabel={customLabel}
                    label={label}
                    workspaceId={parseInt(linkParameters[1])}
                />
            )
        } else if (linkParameters[1] === "create") {
            // WORKSPACE.CREATE => OPENS THE CREATE NEW WORKSPACE PAGE
            return <CreateWorkspace attributes={attributes} label={label} />
        }
    } else if (linkParameters.length === 3) {
        if (linkParameters[1] === "cover" && isNumber(linkParameters[2])) {
            // WORKSPACE.COVER.[WORKSPACEID] => OPENS THE GIVEN WORKSPACE COVER PAGE
            return (
                <WorkspaceCover
                    attributes={attributes}
                    label={label}
                    workspaceId={parseInt(linkParameters[2])}
                />
            )
        } else if (
            linkParameters[1] === "tutorial" &&
            isNumber(linkParameters[2])
        ) {
            // WORKSPACE.TUTORIAL.[WORKSPACEID] => OPENS THE TUTORIAL PAGE FOR THE GIVEN WORKSPACE
            return (
                <WorkspaceTutorial
                    attributes={attributes}
                    label={label}
                    workspaceId={parseInt(linkParameters[2])}
                />
            )
        }
    }

    return <UnavailableLink attributes={attributes} label={label} />
}

export default WorkspaceInternalLink
